import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

// Standard Tailwind className helper:
//   cn('px-2 py-1', condition && 'bg-brand-500', userClassName)
// Merges intelligently so `px-4` from userClassName overrides the default `px-2`.
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
